import { LoadPanel } from 'devextreme-react/load-panel';
import toast from 'fulogics-ui-web/dist/utils/toast';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { PATH_ORDERS } from '../../../constants/routerPaths';
import i18n from '../../../translations/i18n';
import OrderEditForm, { OrderEditFormData } from '../../components/order-edit-form/OrderEditForm';
import DonePopup from './done-popup/DonePopup';
import { OrderNewScreenProps } from './OrderNewScreen';
import styles from './OrderNewScreenComponent.module.scss';

interface OrderNewScreenComponentState {
    isLoading?: boolean;
    donePopupVisible?: boolean;
    //
    order?: OrderEditFormData;
}

const loadingPanelPosition = { of: '#containerRoot' };

export default class OrderNewScreenComponent extends React.Component<
    OrderNewScreenComponentProps,
    OrderNewScreenComponentState
> {
    constructor(props: OrderNewScreenComponentProps) {
        super(props);
        //
        this.state = {
            isLoading: true,
            donePopupVisible: false,
        };
        //
        //this.onFakeDone = this.onFakeDone.bind(this);
        this.onDone = this.onDone.bind(this);
        this.onDonePopupStatusChange = this.onDonePopupStatusChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.createNew || !this.props.singleById) {
        } else {
            // 4
            /*
            this.props.singleById?.("10").then((ro) => {
                this.setState({
                    ...this.state,
                    //
                    isLoading: false,
                    order: ro
                })
            }).catch(error => {
                toast.exception(error);
                log.error("Get new created order.")
            })*/

            this.props.createNew?.({}).then((r) => {
                if (r.id) {
                    this.props
                        .singleById?.(r.id)
                        .then((ro) => {
                            this.setState({
                                ...this.state,
                                //
                                isLoading: false,
                                order: ro,
                            });
                        })
                        .catch((error) => {
                            toast.exception(error);
                        });
                } else {
                }
            });
        }
    }
    /*
        async onFakeDone() {
            this.setState((p) => ({
                ...p,
                isLoading: true,
            }));
            //
            await this.props.fakeOrderSave?.(this.state.order?.id?.toString());
            //
            this.props.history.push(PATH_ORDERS);
        }*/

    async onDone() {
        this.setState((p) => ({
            ...p,
            isLoading: true,
        }));
        //
        this.props.history.push(PATH_ORDERS);
    }

    async onDonePopupStatusChange() {
        this.setState((p) => ({
            ...p,
            donePopupVisible: false,
        }));
    }

    //
    // TIP: możesz mieć problem by zrobić odpowiedni rozmiar diva z formem <- około 90% wysokości, rozwiązanie patrz do src/fulogics-tms.web/src/layout/screens/orders-relization-summary/OrdersRealizationSummaryV2ScreenComponent.tsx
    // ( przyszłościowo będzie to wyciągnięte do HOC-a )
    // onDone w orderForm wywołuje popup
    render() {
        return (
            <div id="containerRoot" className={styles.container}>
                <LoadPanel
                    position={loadingPanelPosition}
                    visible={this.state.isLoading}
                    shadingColor="rgba(0,0,0,0.4)"
                    showIndicator
                    shading
                    showPane
                    closeOnOutsideClick={false}
                />
                {this.state.donePopupVisible && (
                    <DonePopup
                        isVisible={this.state.donePopupVisible}
                        data={this.state.order}
                        onDone={this.onDone}
                        onDonePopupStatusChange={this.onDonePopupStatusChange}
                    />
                )}
                {/*onDone={this.onFakeDone}*/}
                {!this.state.isLoading && (
                    <OrderEditForm
                        data={this.state.order}
                        //
                        doneButtonLabel={i18n.t('OrderNewScreenComponent:doneButtonLabel')}
                        onDone={async () =>
                            this.setState((prev) => ({ ...prev, donePopupVisible: true }))
                        }
                    />
                )}
            </div>
        );
    }
}

type OrderNewScreenComponentProps = OrderNewScreenProps & RouteComponentProps<{}>;
